export default "__VITE_ASSET__f2PFj45u__"